import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import { getRequestApplicantProfileOptions } from '../../../../../api'
import { useScreen, useUserData } from '../../../../../hooks'
import { getItemsFromIdwellApiResponse } from '../../../../../utils/api'
import { isDwellerRole, isStaffUser } from '../../../../../utils/user'
import { FormFieldSelectNG } from '../../../../Form'
import { FormikField, getFormikFormFieldErrorProps } from '../../../../Formik'
import {
  toUserSelectItemsFromOption,
  toUserWithPropertyInfoSelectItemsFromOption,
  UserSelect,
} from '../../../../User'
import {
  REQUEST_WIZARD_INIT_STAGE_FIELD_NAME_BUILDING,
  REQUEST_WIZARD_INIT_STAGE_FIELD_NAME_FLAT,
  REQUEST_WIZARD_INIT_STAGE_FIELD_NAME_USER,
} from '../../RequestWizardForm.constants'

import { getBuildingParam } from './UserField.utils'

function UserField({
  controlProps,
  initialUser,
  isLoading,
  setIsSingleFlat,
  onClear,
}) {
  const { t } = useTranslation()
  const { setFieldValue, values } = useFormikContext()

  const currentUser = useUserData()

  const { isMobileScreenSize } = useScreen() // TODO make same by css media instead of useScreen

  const isStaffUserAcc = isStaffUser(currentUser)

  function handleClearUser() {
    setIsSingleFlat(false)
    onClear?.()
  }

  function handleChangeUser() {
    setIsSingleFlat(false)
    onClear?.()
  }

  const buildingParam = getBuildingParam(
    values[REQUEST_WIZARD_INIT_STAGE_FIELD_NAME_BUILDING],
    values[REQUEST_WIZARD_INIT_STAGE_FIELD_NAME_FLAT]
  )

  useEffect(() => {
    if (isStaffUserAcc && initialUser) {
      const [preparedInitialUser] = toUserWithPropertyInfoSelectItemsFromOption(
        [initialUser]
      )

      if (isDwellerRole(preparedInitialUser)) {
        setFieldValue(
          REQUEST_WIZARD_INIT_STAGE_FIELD_NAME_USER,
          preparedInitialUser
        )
      }
    }
  }, [currentUser, initialUser, isStaffUserAcc, setFieldValue])

  return (
    <FormikField
      Component={FormFieldSelectNG}
      Select={UserSelect}
      apiParams={buildingParam}
      controlProps={{
        ...controlProps,
        borderless: !isMobileScreenSize,
        contentProps: {
          inputProps: {
            placeholder: t('Wizard.UserPlaceholderKey'),
          },
        },
      }}
      disabled={isLoading}
      fieldComponentProps={{
        disabled: isLoading,
        label: `${t('Wizard.UserLabelKey')}:`,
        shouldAdaptToMobileScreen: true,
      }}
      getData={getRequestApplicantProfileOptions}
      getDataItems={getItemsFromIdwellApiResponse}
      getErrorProps={getFormikFormFieldErrorProps}
      name={REQUEST_WIZARD_INIT_STAGE_FIELD_NAME_USER}
      toPreparedItems={toUserSelectItemsFromOption}
      onChange={handleChangeUser}
      onClear={handleClearUser}
    />
  )
}

export default UserField
